/**
 * HomeworkEntry — a task for the client to complete (e.g. "get a topo survey").
 * data: { body: markdown, dueText?: string }
 * Client action: mark done.
 *
 * STUB: registered with authoringFields so the team can already create homework
 * entries; flesh out the completion UX (file upload, etc.) in a later pass —
 * no shell changes required.
 */

import Markdown from '../../components/Markdown.jsx'
import { J, PrimaryButton, DoneChip, ViewOnlyNote } from '../journeyUI.jsx'

export default function HomeworkEntry({ entry, response, onRespond, viewOnly }) {
  const done = response && response.kind === 'homework_done'
  return (
    <div>
      <div style={J.eyebrow}>Homework</div>
      <h2 style={J.title}>{entry.title || 'A task for you'}</h2>
      {entry.data?.dueText && <div style={{ ...J.mono, marginTop: 8 }}>{entry.data.dueText}</div>}
      <hr style={J.rule} />
      <div style={J.body}><Markdown text={entry.data?.body || ''} /></div>
      <div style={{ marginTop: 28 }}>
        {done ? <DoneChip>Marked done</DoneChip>
              : viewOnly ? <ViewOnlyNote>The owner marks this done.</ViewOnlyNote>
              : <PrimaryButton onClick={() => onRespond('homework_done')}>Mark done</PrimaryButton>}
      </div>
    </div>
  )
}
